<template>
  <div class="text-base text-center py-5 text-primary-grey-200" :class="customClass">
    <template v-if="text === 'PICKUP_DISPATCHER_UNAVAILABLE'">
      <span>No Pickup Dispatcher is selected in pickup settings. kindly</span>
      <span class="text-primary-purple-600 cursor-pointer font-bold underline" @click="handleClick">
        Select Pickup Dispatcher
      </span>
      <span>first to use this feature</span>
    </template>
    <p v-else v-i18n="attendanceTranslation">
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    text: {
      type: String,
      default: 'PICKUP_DISPATCHER_UNAVAILABLE',
    },
    customClass: {
      type: String,
      default: '',
    },
    routeName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      attendanceTranslation: 'attendanceTranslation',
    }
  },
  methods: {
    handleClick() {
      this.$router.push({ name: this.routeName })
    },
  },
}
</script>
